import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { PackageName } from '@atlassian/jira-project-settings-apps-common/src/types.tsx';

export const APP_ID = 'project-settings-apps.avatar-modal';
export const PACKAGE_NAME: PackageName = toPackageName('jiraProjectSettingsAppsAvatarModal');
